module.exports = __webpack_public_path__ + "img/05-800x800.6af19910.jpg";